import { EMAILS_GROUPS } from "utils/constants";
import { createExporter } from "utils/createExporter";

const fileName = EMAILS_GROUPS.replace(/[-/]/g, "_");

export const EmailGroupsExporter = createExporter(
  `notification_${fileName}.xlsx`,
  [
    { key: "name", label: "име на групата" },
    { key: "description", label: "статус" },
  ],
  record => ({
    ...record,
  }),
);
